module.exports = __webpack_public_path__ + "img/expeditionary-stage_2.7.0a23ca0b.jpg";